"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../../../atoms");

var _icons_by_group = _interopRequireDefault(require("../assets/icons_by_group.json"));

require("./NotificationIcon.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
var defaultIcon = {
  group: "default",
  type: "View",
  color: "Grey2"
};

var NotificationIcon = function NotificationIcon(_ref) {
  var group = _ref.group,
      _ref$iconSize = _ref.iconSize,
      iconSize = _ref$iconSize === void 0 ? 24 : _ref$iconSize,
      _ref$marginRight = _ref.marginRight,
      marginRight = _ref$marginRight === void 0 ? 8 : _ref$marginRight;
  var icon = defaultIcon;

  var foundIcon = _icons_by_group.default.find(function (icon) {
    return icon.group === group;
  });

  if (foundIcon) {
    icon = foundIcon;
  }

  return /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    marginRight: marginRight,
    height: 40,
    width: 40,
    justifyContent: "center",
    alignItems: "center",
    className: "notifcation-icon"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    size: iconSize,
    type: _atoms.Icon.Type[icon.type],
    color: _atoms.Color[icon.color]
  }));
};

exports.NotificationIcon = NotificationIcon;